import React from 'react';
import { View } from 'react-native';

import InputForm from '../components/InputForm';
import PickerSelect from '../components/PickerSelect';
import DateInput from './DateInput';

import useMonths from '../utils/useTextMonths';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

import { customUDIDEntryTypes, customFieldDataTypes } from '../constants/Enums';

const CustomFieldsFormik = (props) => {
  const {
    reportingFields,
    formikProps,
    object,
    formikGeneralError,
    formikSpecificErrorObject,
    formikObject,
    deploymentMap,
  } = props;
  const [months] = useMonths();
  const { t } = useTranslation(i18nNS.checkout);
  const { tKey } = useComponentTKey('PassengerScreen');

  const onChange = (UDIDText, value, isDropdown = false) => {
    const val = isDropdown ? value.value : value;
    formikProps.setFieldValue(`${object}[${UDIDText}]`, val);
  };

  const hideInput = (DependencyMaps, formikObject) => {
    const isDependent = DependencyMaps !== null;
    if (!isDependent) {
      return false;
    }
    const anyParentHasBeenSelected = DependencyMaps?.some((dependencyMap) => {
      const { CompanyUDIDOptionsKey, SourceUDIDNumber } = dependencyMap;
      return CompanyUDIDOptionsKey.toString() === formikObject[SourceUDIDNumber];
    });
    return !anyParentHasBeenSelected;
  };

  return (
    <View>
      {reportingFields?.map((field) => {
        const {
          UDIDEntryType,
          TextEntry,
          Description,
          DataLength,
          ReportingGroupOptions,
          DependencyMaps,
          UDIDText,
        } = field;
        // dependent inputs will be hidden unless any parent has been selected
        if (hideInput(DependencyMaps, formikObject)) {
          deploymentMap[UDIDText] = false;
          return <></>;
        }

        deploymentMap[UDIDText] = true;
        const {
          TEXT_ENTRY,
          PULL_DOWN,
          PULL_DOWN_WITH_CONDITIONAL_QUESTIONS,
        } = customUDIDEntryTypes;
        const {
          ALPHABET,
          ALPHA_NUMERIC,
          NUMERIC,
          EMAIL,
          ALPHA_NUMERIC_WITH_SPACE,
          ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
          DATE_TIME,
        } = customFieldDataTypes;
        const defaultLength = 30;
        switch (UDIDEntryType) {
          case TEXT_ENTRY:
            switch (TextEntry) {
              case ALPHABET:
              case ALPHA_NUMERIC:
              case NUMERIC:
              case EMAIL:
              case ALPHA_NUMERIC_WITH_SPACE:
              case ALPHA_NUMERIC_WITH_SPECIAL_CHAR:
                return (
                  <InputForm
                    errorMessage={formikGeneralError && formikSpecificErrorObject?.[UDIDText]}
                    keyboardType={TextEntry === NUMERIC ? 'numeric' : 'default'}
                    maxLength={DataLength > 0 ? DataLength : defaultLength}
                    value={formikObject?.[UDIDText]}
                    placeholder={Description}
                    label={Description}
                    onChangeText={(value) => onChange(UDIDText, value)}
                  />
                );
              case DATE_TIME:
                return (
                  <DateInput
                    errorMessage={formikGeneralError && formikSpecificErrorObject?.[UDIDText]}
                    date={formikObject?.[UDIDText]}
                    isEditModeEnabled={true}
                    onDateChange={(value) => onChange(UDIDText, value)}
                    label={Description}
                    months={months}
                    labelMonth={t(tKey('Month'))}
                  />
                );
              default:
                return null;
            }
          case PULL_DOWN_WITH_CONDITIONAL_QUESTIONS:
          case PULL_DOWN: {
            const reportingFieldOptions = ReportingGroupOptions.map((option) => {
              const { CompanyUDIDOptionsKey, UdidOptionText } = option;
              return { value: CompanyUDIDOptionsKey.toString(), label: UdidOptionText };
            });

            return (
              <PickerSelect
                errorMessage={formikGeneralError && formikSpecificErrorObject?.[UDIDText]}
                onValueChange={(value) => onChange(UDIDText, value, true)}
                items={reportingFieldOptions}
                value={formikObject?.[UDIDText]}
                label={Description}
                useDropdown={true}
              />
            );
          }
          default:
            return null;
        }
      })}
    </View>
  );
};

export default CustomFieldsFormik;
